import { THEME, CustomTheme } from './lib/theme/theme'
const TailwindCustomConfig = { THEME }

export { TailwindCustomConfig, CustomTheme }
